export default function mapEnumSelectInput<T>(data: T) {
  return (Object.values(data) as Array<keyof T>).map((id) => ({
    id,
    name: id,
  }));
}
